<script lang="ts" setup>
import { type AccordionRootProps } from 'reka-ui'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@toni/brand-ui'
import { ProductCardWithPurchaseOptions } from '@toni/commerce-api-types'

import { useClient } from '../../utils/is-client'

defineProps<{
  productCards: ProductCardWithPurchaseOptions[]
  accordionOpenId: AccordionRootProps['modelValue']
}>()

const { isClient } = useClient()

const emit = defineEmits(['update-accordion-open-id'])
</script>

<template>
  <Accordion v-if="isClient"
             :model-value="accordionOpenId"
             type="single"
             class="clear-both w-full"
             @update:model-value="emit('update-accordion-open-id', $event)">
    <AccordionItem value="desc">
      <AccordionTrigger>
        <span class="text-heading-xs">{{ $t('commerce.technicalData') }}</span>
      </AccordionTrigger>
      <AccordionContent>
        <div class="flex gap-5 mt-1 mb-4">
          <div v-for="product in productCards"
               :key="product.bauerProductCard.bauerProductCardId"
               class="flex-row"
               :class="productCards.length > 2 ? 'basis-1/4' : 'basis-1/2'">
            {{ product.bauerProductCard.description }}
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
